import {
  employeeItems,
  employeeCreate,
  employeeDetails,
  departmentCreate,
  departmentItems,
  depDetails,
  indexPageInfo,
  employeeUpdate,
  employeeDepHeadEmp,
  employeeDeparture
} from '@/api/employee'

const employee = {
  state: {

  },
  mutations: {

  },
  actions: {
    EmployeeDeparture ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeDeparture(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeDepHeadEmp ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeDepHeadEmp(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeUpdate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeIndexPageInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        indexPageInfo().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    EmployeeCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        employeeCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DepartmentCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        departmentCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DepartmentItems ({ commit }) {
      return new Promise((resolve, reject) => {
        departmentItems().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DepDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        depDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default employee



// WEBPACK FOOTER //
// ./src/store/modules/employee.js